import live_status_20 from "@/assets/icon_live.gif";
import React from "react";
import styles from "./index.module.less";

interface LiveStatusProps {
  liveData?: any;
}

const LiveStatus: React.FC<LiveStatusProps> = ({ liveData }) => {
  const { liveStatus, liveStatusDesc, playBackUrl } = liveData || {};
  let status = "status_icon_20";
  let src =
    "https://akim-oss.aikucun.com/7f19fb40c0814f2549e83a200e45bebe5b96e3b3_1763107020162_13.png";
  if (liveStatus === 10) {
    src =
      "https://akim-oss.aikucun.com/22b99762d7fd32ecaecd83afa430d9e2fc07854a_1763107020161_23.png";
  } else if (liveStatus === 20) {
    src = live_status_20;
  } else if (liveStatus > 20 && playBackUrl) {
    src =
      "https://akim-oss.aikucun.com/23903dc1bfce16c50b12337b69bdf71417f82f40_1763107020162_66.png";
  }
  return (
    <div className={styles.live_status}>
      <img className={styles[status]} src={src} />
      <span className={styles.status_text}>{liveStatusDesc}</span>
    </div>
  );
};

export default LiveStatus;
